import React from 'react';
import { useDrag, useDrop } from 'react-dnd';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

const ItemType = "EVENT";

const DraggableEvent = ({ event, index, moveEvent, handleEventClick, renderArrow, disabled, columns = 4 }) => {
    const ref = React.useRef(null);

    const [{ isDragging }, drag] = useDrag({
        type: ItemType,
        item: { index },
        begin: (monitor) => {
            try { console.log('[DnD] begin drag index=', index, 'id=', event && (event.id || event.originalIndex)); } catch(e) {}
        },
        end: (item, monitor) => {
            try { console.log('[DnD] end drag item=', item); } catch(e) {}
        },
        collect: (monitor) => ({
            isDragging: !disabled ? monitor.isDragging() : false,
        }),
    });

    const [, drop] = useDrop({
        accept: ItemType,
        hover: (draggedItem, monitor) => {
            if (!ref.current) return;
            // Debug logging for hover indices
            try {
                // eslint-disable-next-line no-console
                console.log('[DnD] hover: draggedIndex=', draggedItem.index, 'targetIndex=', index);
            } catch (e) {}

            if (draggedItem.index === index || !event || disabled) return;

            const hoverBoundingRect = ref.current.getBoundingClientRect();
            const clientOffset = monitor.getClientOffset();
            if (!clientOffset) return;

            const hoverMiddleX = (hoverBoundingRect.right - hoverBoundingRect.left) / 2;
            const hoverClientX = clientOffset.x - hoverBoundingRect.left;

            // Only perform the move when the mouse has crossed half of the item's width
            if (draggedItem.index < index && hoverClientX < hoverMiddleX) return;
            if (draggedItem.index > index && hoverClientX > hoverMiddleX) return;

            moveEvent(draggedItem.index, index);
            draggedItem.index = index;
        },
    });

    drag(drop(ref));

    const getHeaderColor = (type) => {
        switch (type) {
            case 'Event':
                return 'orange';
            case 'Break':
                return 'purple';
            case 'Lunch':
                return 'red';
            default:
                return 'gray';
        }
    };

    return (
        <div ref={ref} style={{ opacity: isDragging ? 0.5 : 1 }}>
            <Paper
                onClick={() => { 
                    if (!disabled) {
                        // handleEventClick is passed as a closure from parent (already bound to playback index)
                        handleEventClick && handleEventClick(); 
                    }
                }}
                style={{
                    padding: '15px',
                    paddingTop: '8px',
                    textAlign: 'center',
                    cursor: 'pointer',
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    borderTop: `10px solid ${getHeaderColor(event.type)}`,
                }}
            >
                <Typography variant="h6">{event.name}</Typography>
                <Typography variant="body2">{event.duration} min</Typography>
                <Typography variant="body2">{event.type}</Typography>
                {renderArrow && renderArrow()}
            </Paper>
        </div>
    );
};

export default DraggableEvent;

